import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEYS } from '@avanta/shared/constants/common';
import { PatientService } from '@avanta/shared/services/patients';
import { type User } from '@avanta/shared/types/users';

export const useFetchPatient = (patientId?: string): UseQueryResult<User | undefined, Error> =>
  useQuery({
    queryKey: [QUERY_KEYS.FETCH_PATIENT, patientId],
    queryFn: async () => await PatientService.getPatient(patientId),
    select: response => response.data,
    enabled: !!patientId,
  });
